export default __webpack_public_path__ + "static/media/hydration@2x.4f3acafb.jpg";